const LOAD_DATA_MASTER_JOB_DESTINATION         = 'LOAD_DATA_MASTER_JOB_DESTINATION'
const LOAD_DATA_MASTER_JOB_DESTINATION_SUCCESS = 'LOAD_DATA_MASTER_JOB_DESTINATION_SUCCESS'
const LOAD_DATA_MASTER_JOB_DESTINATION_FAILED  = 'LOAD_DATA_MASTER_JOB_DESTINATION_FAILED'
const UNMOUNT_DATA_MASTER_JOB_DESTINATION      = 'UNMOUNT_DATA_MASTER_JOB_DESTINATION'

const initialState = {
  loading: true,
  data: null,
  message: null
}

const jobDestinationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_DATA_MASTER_JOB_DESTINATION:
      return {
        ...state,
        loading: true,
        data: null
      }
    case LOAD_DATA_MASTER_JOB_DESTINATION_SUCCESS:
      return {
        ...state, 
        loading: false,
        data: action.payload.data,
        message: 'SUCCESS'
      }
    case LOAD_DATA_MASTER_JOB_DESTINATION_FAILED:
      return {
        ...state, 
        loading: false,
        data: null,
        message: 'FAILED'
      }
    case UNMOUNT_DATA_MASTER_JOB_DESTINATION:
      return { 
        ...state, 
        loading: true,
        data: null
      }
    default:
      return state
  }
}
export default jobDestinationReducer